// BASE_ID: 20260816R1219_2A

import { getDomainRoute, normalizeHostname } from "../../config/domains";

function normalizeProtocol(protocol = "https:") {
  const value = String(protocol || "").trim().toLowerCase();
  return value === "http:" || value === "https:" ? value : "https:";
}

function normalizePathname(pathname = "/") {
  const value = String(pathname || "/");
  if (!value) return "/";
  return value.startsWith("/") ? value : `/${value}`;
}

function normalizeSuffix(value = "", prefix) {
  const raw = String(value || "");
  if (!raw) return "";
  return raw.startsWith(prefix) ? raw : `${prefix}${raw}`;
}

export function resolveTrdrPokemonCanonicalHostRedirect({
  protocol = "https:",
  hostname = "",
  port = "",
  pathname = "/",
  search = "",
  hash = "",
} = {}) {
  const normalizedHostname = normalizeHostname(hostname);
  const route = getDomainRoute(normalizedHostname);
  const canonicalHostname = normalizeHostname(route?.hostname);
  const isPokemonHost = route?.verticalId === "pokemon";
  const isAlias = Boolean(
    isPokemonHost && canonicalHostname && normalizedHostname && normalizedHostname !== canonicalHostname
  );

  if (!isAlias) {
    return Object.freeze({
      redirect: false,
      sourceHostname: normalizedHostname,
      canonicalHostname: canonicalHostname || "",
      targetUrl: "",
    });
  }

  const normalizedPort = String(port || "").trim().replace(/^:/, "");
  const hostWithPort = normalizedPort
    ? `${canonicalHostname}:${normalizedPort}`
    : canonicalHostname;
  const targetUrl = `${normalizeProtocol(protocol)}//${hostWithPort}${normalizePathname(
    pathname
  )}${normalizeSuffix(search, "?")}${normalizeSuffix(hash, "#")}`;

  return Object.freeze({
    redirect: true,
    sourceHostname: normalizedHostname,
    canonicalHostname,
    targetUrl,
  });
}

export function enforceTrdrPokemonCanonicalBrowserHost(locationLike) {
  const locationRef =
    locationLike || (typeof window !== "undefined" ? window.location : null);
  if (!locationRef) return false;

  const resolution = resolveTrdrPokemonCanonicalHostRedirect({
    protocol: locationRef.protocol,
    hostname: locationRef.hostname,
    port: locationRef.port,
    pathname: locationRef.pathname,
    search: locationRef.search,
    hash: locationRef.hash,
  });

  if (!resolution.redirect || !resolution.targetUrl) return false;
  if (typeof locationRef.replace !== "function") return false;

  locationRef.replace(resolution.targetUrl);
  return true;
}
